export default __webpack_public_path__ + "static/media/320x180.7d83df18.jpg";